import { KeyCodeUI } from "./key-code-ui";
import { useState } from "react";
import _ from 'lodash';

import Comparer from "../../app/comparer";

export const PropertyKeyCodesTab = ({ propertyDocument, propertyApi }) => {

    const [keyCodes, setKeyCodes] = useState(propertyDocument.property.keyCodes);

    const updateValue = (keyVal, kc) => {
        setKeyCodes(currentArray => {
            const index = _.findIndex(currentArray, ca => ca.name === kc.name);
            currentArray.splice(index, 1); // Remove current version
            const result = [].concat(currentArray, { name: kc.name, value: parseInt(keyVal) });
            return result;
        });
    };

    const updateName = (keyVal, kc) => {
        setKeyCodes(currentArray => {
            const index = _.findIndex(currentArray, ca => ca.name === kc.name);
            currentArray.splice(index, 1); // Remove current version
            const result = [].concat(currentArray, { name: keyVal, value: kc.value });
            return result;
        });
    };

    const addNewCode = () => {
        setKeyCodes(currentArray => {
            const result = sortedKeyCodes([].concat(currentArray, { displayOrder: currentArray.length, name: "Change Me", value: 1234 }));
            return result;
        })
    };

    const sortedKeyCodes = (kc) => {
        return _.orderBy(kc, kc => kc.displayOrder, "asc").map((kc, i) => {
            kc.displayOrder = i;
            return kc;
        });
    }

    const comparer = new Comparer();

    const canSave = () => {

        const equal = comparer.equals(keyCodes, propertyDocument.property.keyCodes);
        return !equal;
    }

    const save = () => {
        if (canSave()) {
            propertyDocument.property.keyCodes = keyCodes;
            propertyApi.upsertProperty(propertyDocument)
                .then(propDoc => setKeyCodes(propDoc.property.keyCodes));
        }
    };

    const canMoveDown = (index, length) => {
        return index < length - 1;
    };

    const canMoveUp = (index, length) => {
        return index > 0 && length > 0 && index <= length;
    };

    const moveDown = (kc) => {
        setKeyCodes(currentArray => {

            let sortedArray = sortedKeyCodes(currentArray);

            const itemBelowIndex = Math.min(kc.displayOrder + 1, currentArray.length - 1);
            const itemBelow = _.find(sortedArray, ca => ca.displayOrder === itemBelowIndex);
            const itemBeingMoved = _.find(sortedArray, ca => ca.displayOrder === kc.displayOrder);

            itemBeingMoved.displayOrder = itemBeingMoved.displayOrder + 1;
            itemBelow.displayOrder = itemBelow.displayOrder - 1;

            sortedArray = sortedKeyCodes(sortedArray);
            return sortedArray;
        });

    };

    const moveUp = (kc) => {
        setKeyCodes(currentArray => {

            const itemAboveIndex = Math.max(kc.displayOrder - 1, 0);
            const itemAbove = _.find(currentArray, ca => ca.displayOrder === itemAboveIndex);
            const itemBeingMoved = _.find(currentArray, ca => ca.displayOrder === kc.displayOrder);

            itemAbove.displayOrder = itemAbove.displayOrder + 1;
            itemBeingMoved.displayOrder = itemBeingMoved.displayOrder - 1;

            const sortedArray = sortedKeyCodes(currentArray);
            return sortedArray;
        });
    };

    return (
        <div className="tab-pane fade" id="nav-pills-tab-keycodes">
            <div className="keycode-container">
                <div className="keycode-header">
                    <h3 className="keycode-title">
                        <i className="fa fa-key"></i>
                        Security Key Codes
                    </h3>
                    <div className="keycode-actions">
                        <button 
                            title='Add New Key Code' 
                            className="btn btn-success btn-add-keycode" 
                            onClick={addNewCode}
                        >
                            <i className="fa fa-plus"></i>&nbsp;&nbsp;Add Code
                        </button>
                        <button 
                            title='Save Changes' 
                            disabled={!canSave()} 
                            className="btn btn-primary btn-save-keycode" 
                            onClick={save}
                        >
                            <i className="fa fa-save"></i>&nbsp;&nbsp;Save Changes
                        </button>
                    </div>
                </div>

                {keyCodes && keyCodes.length > 0 ? (
                    <div className="keycode-list">
                        {sortedKeyCodes(keyCodes).map((kc, i) =>
                            <KeyCodeUI 
                                key={`${kc.name}-${kc.value}-${i}`} 
                                keyCode={kc}
                                onChange={keyVal => updateValue(keyVal, kc)}
                                onChangeName={keyVal => updateName(keyVal, kc)}
                                canMoveDown={canMoveDown(i, keyCodes.length)}
                                canMoveUp={canMoveUp(i, keyCodes.length)}
                                moveDown={moveDown}
                                moveUp={moveUp}
                            />
                        )}
                    </div>
                ) : (
                    <div className="keycode-empty-state">
                        <i className="fa fa-key"></i>
                        <h4>No Key Codes Added</h4>
                        <p>Add security key codes for boxes installed at this property</p>
                    </div>
                )}
            </div>
        </div>
    );
}